import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ForgotPasswordPayload, ForgotPasswordResponse } from "./forgot-password.entity";
import { forgotPassword } from "./forgot-password.api";

interface ForgotPasswordState {
  email: string;
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
}

const initialState: ForgotPasswordState = {
  email: "",
  loading: false,
  error: null,
  success: false,
  message: null,
};

export const sendPasswordResetEmail = createAsyncThunk<
  ForgotPasswordResponse,
  ForgotPasswordPayload
>("forgotPassword/sendPasswordResetEmail", async (payload) => {
  return await forgotPassword(payload);
});

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    clearForgotPasswordState(state) {
      state.email = "";
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendPasswordResetEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(sendPasswordResetEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(sendPasswordResetEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to send password reset email";
        state.success = false;
      });
  },
});

export const { clearForgotPasswordState } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;

